import SaveObjectUseCase from "./SaveObjectUseCase";
import FindObjectUseCase from "./FindObjectUseCase";
import GetObjectUseCase from "./GetObjectUseCase";
import UpdateObjectUseCase from "./UpdateObjectUseCase";
import DeleteObjectUseCase from "./DeleteObjectUseCase";
import UpsertUseCase from "./UpsertUseCase";
import AggregateUseCase from "./AggregateUseCase";
import CountObjectUseCase from "./CountObjectUseCase";
import {
  recordDeleteAudit,
  recordUpsertAudit,
} from "../logs/recordAuditLog";

class AuditedUpsertUseCase {
  constructor() {
    this._useCase = new UpsertUseCase();
  }

  async execute(collection, object, options = {}) {
    if (!options.skipAudit) {
      try {
        await recordUpsertAudit(collection, object);
      } catch (e) {
        console.error(e.message || e);
      }
    }
    return this._useCase.execute(collection, object);
  }
}

class AuditedDeleteObjectUseCase {
  constructor() {
    this._useCase = new DeleteObjectUseCase();
  }

  async execute(collection, id, options) {
    try {
      await recordDeleteAudit(collection, id);
    } catch (e) {
      console.error(e.message || e);
    }
    return this._useCase.execute(collection, id, options);
  }
}

export function saveObjectUseCase() {
  return new SaveObjectUseCase();
}

export function findObjectUseCase() {
  return new FindObjectUseCase();
}

export function updateObjectUseCase() {
  return new UpdateObjectUseCase();
}

export function deleteObjectUseCase() {
  return new AuditedDeleteObjectUseCase();
}

export function upsertUseCase() {
  return new AuditedUpsertUseCase();
}

export function getObjectUseCase() {
  return new GetObjectUseCase();
}

export function aggregateUseCase() {
  return new AggregateUseCase();
}

export function countObjectUseCase() {
  return new CountObjectUseCase();
}

export { UpsertUseCase, DeleteObjectUseCase };
